<template>
    <v-content class="pa-12">
        <v-layout justify-space-around>
            <v-flex d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
                <span>งานวิจัยขอยกเลิกโครงการ</span>
            </v-flex>
        </v-layout>
        <!--search-->
        <v-row>
            <v-col cols="3">
                <v-text-field placeholder="รหัสโครงการวิจัย" color="#3e7662" dense outlined hide-details
                    v-model="searchData.researchCode" />
            </v-col>
            <v-col cols="3">
                <v-text-field placeholder="ชื่อ นามสกุล ผู้วิจัย" color="#3e7662" dense outlined hide-details
                    v-model="searchData.researcherName" />
            </v-col>
            <v-col cols="3">
                <v-text-field placeholder="เลขรับ" color="#3e7662" dense outlined hide-details
                    v-model="searchData.initialNumber" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3">
                <v-select hide-details clearable :menu-props="{ bottom: true, offsetY: true }"
                    background-color="#3e7662" dark solo flat dense label="สถานะงานวิจัย" :items="statusList"
                    item-text="name" item-value="name" v-model="searchData.status" />
            </v-col>
            <v-col cols="3">
                <v-select hide-details clearable :menu-props="{ bottom: true, offsetY: true }"
                    background-color="#3e7662" dark solo flat dense label="ประเภทการพิจารณา" :items="considerationType"
                    item-text="name" item-value="id" v-model="searchData.considerationType_id" />
            </v-col>
            <v-col cols="3">
                <v-text-field placeholder="ชื่อโครงการวิจัย" color="#3e7662" dense outlined hide-details
                    v-model="searchData.researchName" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3">
                <DateInputForm :model="dateChange.startDate" @update-data="updateDate('startDate', $event)"
                    label="ตั้งแต่">
                </DateInputForm>
            </v-col>
            <v-col cols="3">
                <DateInputForm :model="dateChange.endDate" @update-data="updateDate('endDate', $event)" label="จนถึง">
                </DateInputForm>
            </v-col>
            <v-col class="shrink d-flex justify-end">
                <v-btn color="#3e7662" dark @click="search(1)">
                    <span class="font-weight-bold">ค้นหา</span>
                </v-btn>
            </v-col>
        </v-row>
        <v-layout>
            <v-flex>
                <form-table :headers="headers" :items="cannelReseacsh" onViewData :acceptCancel="acceptCancel"
                    :viewDatacancel="viewDatacancel">

                </form-table>
            </v-flex>
        </v-layout>

        <v-layout mt-12>
            <v-flex>
                <v-pagination color="#3E7662" :length="paginateResearch.last_page" :total-visible="9"
                    @input="search($event)" v-model="paginateResearch.current_page"></v-pagination>
            </v-flex>
        </v-layout>


        <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>

    </v-content>
</template>

<script>

import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import DateInputForm from "../../components/input/DateInputForm";
import FormTable from "../../components/table/FormTable";
import { mapState, mapActions } from "vuex";
import { domain } from "../../services/Constants";
import axios from "axios";


export default {
    components: {
        DateInputForm,
        Loading,
        FormTable,
    },
    data: () => ({
        headers: [
            {
                text: "ลำดับ",
                value: "number",
                align: "center",
                sortable: false,
                class: "header-data-table",
            },
            {
                text: "ชื่องานวิจัย",
                value: "researchname",
                align: "center",
                sortable: false,
                width: "20%",
            },
            {
                text: "ชื่อผู้วิจัย",
                value: "researchername",
                align: "center",
                sortable: false,
                width: "20%",
            },
            { text: "สถานะ", value: "status", align: "center", sortable: false, width: "25%" },
            {
                text: "เลขรับ (Initial), รหัสโครงการวิจัย, ประเภทการพิจารณา",
                value: "initial",
                align: "center",
                sortable: false,
            },
            { text: "วันที่ส่ง", value: "signDate", align: "center", sortable: false },
            {
                text: "อนุมัติขอยกเลิก",
                value: "accept",
                align: "center",
                sortable: false,
            },
            { text: "ดูเอกสารขอยกเลิก", value: "viewDoc", align: "center", sortable: false },
        ],
        cannelReseacsh: [],
        isLoading: false,
        fullPage: true,
        statusList: [
            { id: 1, name: "รอดำเนินขอยกเลิกโครงการ" },
            { id: 2, name: "งานวิจัยที่ปิดโครงการ" }
        ],
        considerationType: [
            { id: "0", value: "0", name: "ทั้งหมด", isResubmission: "0" },
            { id: "1", value: "1", name: "ประเภท Full Board", isResubmission: "0" },
            { id: "2", value: "2", name: "ประเภท Expedited", isResubmission: "0" },
            { id: "3", value: "3", name: "ประเภท Exemption", isResubmission: "0" },
            { id: "4", value: "1", name: "ประเภท Full Board (แก้ไขเพื่อรับรอง)", isResubmission: "1" },
            { id: "5", value: "2", name: "ประเภท Expedited (แก้ไขเพื่อรับรอง)", isResubmission: "1" },
        ],
        searchData: {
            startDate: '',
            endDate: '',
            researchCode: "",
            researcherName: "",
            status: "",
            considerationType_id: "0",
            considerationType: "0",
            initialNumber: "",
            isResubmission: "0",
            researchName: ""
        },
        dateChange: {
            startDate: '',
            endDate: ''
        },
        paginateResearch: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1,
        },
        paginateSearch: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1,
        },
    }),
    computed: {
        ...mapState({
            user: (state) => state.Auth.user,
            role: (state) => state.Auth.role,
        }),
    },
    created() {
        this.getCancelResearch();
    },
    methods: {
        getCancelResearch() {
            this.isLoading = true;
            this.$store.dispatch("Research/getCancelResearch", this.searchData).then((res) => {
                this.cannelReseacsh = [];
                let i = 1;
                res.data.forEach((data) => {
                    console.log(data);
                    this.cannelReseacsh.push({
                        number: i,
                        researchname: data.thResearchName,
                        researchername: data.user.thFirstName + " " + data.user.thLastName,
                        status: data.status,
                        initial: data.initialNumber ? data.initialNumber : "-",
                        researchCode: data.researchCode,
                        signDate: data.sendDate.substr(0, 10) ?? "-",
                        onView: 15,
                        id: data.id,
                        pdf: data.cancelResearchFile,
                    });
                    i++;
                });
                this.paginateResearch.current_page = res.current_page;
                this.paginateResearch.from = res.from;
                this.paginateResearch.last_page = res.last_page;
                this.paginateResearch.per_page = res.per_page;
                this.paginateResearch.total = res.total;
                this.paginateResearch.to = res.to;
                this.isLoading = false;
            }).catch((e) => {
                this.isLoading = false;
            });
        },
        search(page) {
            this.isLoading = true;
            this.searchData.page = page;
            let considerType = this.considerationType.find(x => x.id === this.searchData.considerationType_id);
            this.searchData.isResubmission = considerType.isResubmission
            this.searchData.considerationType = considerType.value
            this.$store
                .dispatch("Research/getCancelResearch", this.searchData)
                .then((res) => {
                    this.cannelReseacsh = [];
                    let i = 1;
                    res.data.forEach((data) => {
                        console.log(data);
                        this.cannelReseacsh.push({
                            number: i,
                            researchname: data.thResearchName,
                            researchername: data.user.thFirstName + " " + data.user.thLastName,
                            status: data.status,
                            initial: data.initialNumber ? data.initialNumber : "-",
                            signDate: data.sendDate ?? "-",
                            onView: 15,
                            id: data.id,
                            pdf: data.cancelResearchFile,
                        });
                        i++;
                    });
                    this.paginateResearch.current_page = res.current_page;
                    this.paginateResearch.from = res.from;
                    this.paginateResearch.last_page = res.last_page;
                    this.paginateResearch.per_page = res.per_page;
                    this.paginateResearch.total = res.total;
                    this.paginateResearch.to = res.to;
                    this.isLoading = false;
                })
                .catch((e) => {
                    this.isLoading = false;
                    Swal.fire({
                        title: "ไม่พบงานวิจัย",
                        icon: "error",
                        position: "center",
                        confirmButtonText: "ตกลง",
                        confirmButtonColor: "#3E7662",
                    }).then(() => {
                        this.searchData = {
                            startDate: '',
                            endDate: '',
                            researchCode: "",
                            researcherName: "",
                            researchName: "",
                            status: "",
                            considerationType_id: "0",
                            considerationType: "0",
                            initialNumber: "",
                            isResubmission: "0"
                        }
                        this.search(1);
                    });
                });
        },
        acceptCancel(data) {
            Swal.fire({
                title: "คุณต้องการอนุมัติคำขอยกเลิกงานวิจัย ใช่หรือไม่ ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3E7662",
                cancelButtonColor: "rgb(189, 189, 189)",
                cancelButtonText: "ไม่ต้องการ",
                confirmButtonText: "ต้องการ",
            }).then((result) => {
                this.isLoading = true;
                if (result.value == true) {
                    this.$store.dispatch('Research/acceptCancelResearch', data).then((res) => {
                        this.isLoading = true;
                        Swal.fire({
                            position: "center",
                            title: "อนุมัติเรียบร้อยแล้ว",
                            icon: "success",
                            showCancelButton: false,
                            timer: 1500,
                        }).then(() => {
                            this.isLoading = false;
                        }).catch((e) => {
                            Swal.fire({
                                title: "failed!",
                                text: "อนุมัติไม่สำเร็จ",
                                icon: "warning",
                            }).then(() => {
                                this.isLoading = false;
                            });
                        });
                    });
                }
                this.isLoading = false;
            });
        },
        viewDatacancel(data) {
            window.open(domain + 'storage/upload/cancel-research-file/' + data.pdf);
        },
        updateDate(name, val) {
            if (name === "approvalDate") {
                this.considerResultForm.approvalDate = val.date;
                this.approvalDate = this.changeDate(val.date);
            } else {
                this.searchData[name] = val.date;
                this.dateChange[name] = this.changeDate(val.date);
            }
        },
        changeDate(val) {
            //change date start
            let sub_year = val.substring(0, 4);
            let sub_month = val.substring(5, 7);
            let sub_day = val.substring(8, 10);

            sub_year = parseInt(sub_year) + 543;

            let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
            return changeDate;
        },
    }
}
</script>